import { render, staticRenderFns } from "./InvestmentContacts.vue?vue&type=template&id=df5ef45a"
import script from "./InvestmentContacts.vue?vue&type=script&lang=js"
export * from "./InvestmentContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports